export const getStaticMapUrl = ({ lat, lng, zoom = 10, apiKey }) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&scale=1&zoom=${zoom}&format=png&maptype=roadmap&size=300x280&key=${apiKey}`;

export default {
  getStaticMapUrl
};
